import script from "./Page16.vue?vue&type=script&setup=true&lang=js"
export * from "./Page16.vue?vue&type=script&setup=true&lang=js"

import "./Page16.vue?vue&type=style&index=0&id=3c29d2fe&lang=less"

const __exports__ = script;

export default __exports__